import React, { useEffect, useMemo, useState } from "react";

// Aug-2026 (User-Wunsch) — Verkäufer-Auswahl mit Status-Kennzeichnung:
// abwesend (Urlaub/krank/frei/Schule) = ausgegraut/nicht wählbar,
// nicht eingestempelt = wählbar aber gekennzeichnet, fehlende Funktion markiert.
// Hauptsitz (mehrere Standorte): 2-stufig — erst Standort, dann Verkäufer.

const fmtD = (iso) => { try { return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch { return iso || ""; } };
const baseName = (e) => (e.name || "").split(" · ")[0];

export const empOptionLabel = (e, stripSite = false) => {
    let t = stripSite ? baseName(e) : (e.name || "");
    if (e.function_missing) t += " (Funktion fehlt)";
    if (e.absent) t += ` — abwesend${e.absent_label ? ` (${e.absent_label})` : ""}${e.absent_until ? ` bis ${fmtD(e.absent_until)}` : ""}`;
    else if (e.clocked_in === false) t += " — noch nicht eingestempelt";
    return t;
};

export function SellerSelect({ employees, value, onChange, disabled, className = "", placeholder = "— nicht zugewiesen —", testid }) {
    const sites = useMemo(() => {
        const s = [...new Set(employees.map((e) => e.site_code || ""))];
        return s.length > 1 ? s.sort((a, b) => (a || "zzz").localeCompare(b || "zzz")) : null;
    }, [employees]);
    const valueSite = useMemo(() => {
        const e = employees.find((x) => x.id === value);
        return e ? (e.site_code || "") : null;
    }, [employees, value]);
    const [site, setSite] = useState(null);
    useEffect(() => { if (valueSite !== null) setSite(valueSite); }, [valueSite]);

    if (!sites) {
        return (
            <select value={value || ""} disabled={disabled} onChange={(e) => onChange(e.target.value)}
                className={className} title="Verkäufer zuweisen" data-testid={testid}>
                <option value="">{placeholder}</option>
                {employees.map((e) => (
                    <option key={e.id} value={e.id} disabled={!!e.absent}>{empOptionLabel(e)}</option>
                ))}
            </select>
        );
    }
    const chosen = site !== null;
    const list = employees.filter((e) => (e.site_code || "") === (site || ""));
    return (
        <span className="inline-flex items-center gap-1 flex-wrap">
            <select value={chosen ? (site || "__hq__") : ""} disabled={disabled}
                onChange={(e) => setSite(e.target.value === "" ? null : (e.target.value === "__hq__" ? "" : e.target.value))}
                className={className} title="1. Standort wählen" data-testid={testid ? `${testid}-site` : undefined}>
                <option value="">— Standort wählen —</option>
                {sites.map((s) => <option key={s || "__hq__"} value={s || "__hq__"}>{s || "Hauptsitz"}</option>)}
            </select>
            {chosen && (
                <select value={value || ""} disabled={disabled} onChange={(e) => onChange(e.target.value)}
                    className={className} title="2. Verkäufer wählen" data-testid={testid}>
                    <option value="">{placeholder}</option>
                    {list.map((e) => (
                        <option key={e.id} value={e.id} disabled={!!e.absent}>{empOptionLabel(e, true)}</option>
                    ))}
                </select>
            )}
        </span>
    );
}
